import { useInstance } from "@meraki-internal/react-dependency-injection";
import { useEffect } from "react";
import { History } from "./History";
import { HeaderAndNavigationBar } from "./HeaderAndNavigationBar";
import { HeroBanner } from "./HeroBanner";
import { OurMission } from "./OurMission";
import { HeroCampaignV2 } from "./HeroCampaign";
import { OtherFundingCampaigns } from "./OtherFundingCampaigns";
import { Metrics } from "./Metrics";
import { Events } from "./Events";
import { OurVolunteers } from "./OurVolunteers";
import { OurSponsors } from "./OurSponsors";
import { OurStudentTestimonials } from "./OurStudentTestimonials";
import { TeamMap } from "./TeamMap";
import { Footer } from "./Footer";

export const Home: React.FC = () => {
    const history = useInstance(History);


    useEffect(()=> {

        const maybeScrollToId = () => {
            const scrollTo = history.getQueryParam('scroll');

            if (scrollTo){
                const el = document.querySelector(`#${scrollTo}`);
                if (el){
                    el.scrollIntoView({ behavior: 'smooth' });
                }
            }
            else {
                // TODO: this isn't smooth, but ignoring for now
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }

        window.addEventListener('hashchange', maybeScrollToId);

        maybeScrollToId();

        return () => {
            window.removeEventListener('hashchange', maybeScrollToId);
        }

    }, [history]);

    return (
        <div className="home">
            <HeaderAndNavigationBar />
            <HeroBanner />
            <OurMission />
            <hr />
            <OtherFundingCampaigns />
            {/* <Metrics /> */}
            <Events />
            <hr />
            <OurVolunteers />
            <OurSponsors />
            <OurStudentTestimonials />
            <TeamMap />
            <Footer />
        </div>
    )
}